import i from './master-truck.container';

export default i;
